import { render, staticRenderFns } from "./EditComponentModal.vue?vue&type=template&id=1d3e22d0&"
import script from "./EditComponentModal.vue?vue&type=script&lang=js&"
export * from "./EditComponentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports